// @flow
import { selectCartReferer } from '@gandi/cart';

import { selectPersonalId } from '@gandi/redux-sharing';

import type { FullState } from '../../../types';

export const selectIsUserSameAsReferer = (state: FullState): boolean => {
  const userId = selectPersonalId(state);
  const refererId = selectCartReferer(state);
  return userId === refererId;
};
